import { defineMessages } from 'react-intl'


export default defineMessages({
  weAndOurVendors: {
    defaultMessage: 'We and our <vendorLink>vendors ({vendorCount})</vendorLink> use cookies and similar technologies to read, store, and write information on your device. Essential cookies are necessary for our site to work properly. With your consent, we and our vendors may also use non-essential cookies to improve user experience, personalize advertisements, and analyze website traffic. For these reasons, we may process your personal data (such as IP address or browsing and interaction data).',
    id: 'tcf-consent-message.vendor-paragraph',
  },
})
